/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import './style/snackbar.scss';

import React from 'react';
import classNames from 'classnames';
import {convertColor} from "../util/colorUtil";
import {ControlContext} from "../util/controlContext";
import {Snack} from "../util/interfaces";

interface ViewProps {
    onClick: any;
    snack: Snack | null;
    containerClass: string;
    textClass: string;
    backgroundColor?: string;
    textColor?: string;
    active: boolean;
}

export class Snackbar extends React.Component<ViewProps> {
    // noinspection JSUnusedGlobalSymbols
    declare context: React.ContextType<typeof ControlContext>;
    static contextType = ControlContext;

    getBackgroundColor = (): string => {
        const {backgroundColor, snack} = this.props;
        if (snack?.config?.backgroundColor) return convertColor(snack.config.backgroundColor);
        if (backgroundColor) return convertColor(backgroundColor);
        // noinspection JSDeprecatedSymbols
        return convertColor(this.context.baseColor);
    };

    getTextColor = (): string => {
        const {textColor, snack} = this.props;
        if (snack?.config?.textColor) return convertColor(snack.config.textColor);
        if (textColor !== undefined && textColor !== null) return convertColor(textColor);
        // noinspection JSDeprecatedSymbols
        return convertColor(this.context.contrastColor);
    };

    getBackgroundStyle = (): { backgroundColor: string } => ({backgroundColor: this.getBackgroundColor()});

    getTextStyle = (): { color: string } => ({color: this.getTextColor()});

    renderText = () => {
        const {snack, textClass} = this.props;
        if (!snack) return null;
        const {text} = snack;
        let element: React.ReactNode = null;
        if (typeof text === 'string') element =
            <label className={classNames('snackBarText', textClass)} style={this.getTextStyle()}>{text}</label>;
        else if (text) {
            const className = Object.assign({}, text.props?.className, classNames('snackBarText', textClass)),
                style = Object.assign({}, text.props?.style, this.getTextStyle());
            element = React.cloneElement(text, {className, style});
        }
        return element;
    }

    render = () => {
        const {containerClass, active, onClick} = this.props;
        return (
            <div className={classNames('snackbar', active && 'active', containerClass)}
                 style={this.getBackgroundStyle()} onClick={onClick}>
                {this.renderText()}
            </div>
        );
    };
}